import script from "./Details.vue?vue&type=script&setup=true&lang=ts"
export * from "./Details.vue?vue&type=script&setup=true&lang=ts"

import "./Details.vue?vue&type=style&index=0&id=93cc81c8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-93cc81c8"]])

export default __exports__